var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stages-bar-container"},[_c('ProgressBar',{attrs:{"done":_vm.quizIndex/(_vm.questions.length),"nearly-done":_vm.quizIndex/(_vm.questions.length-1)>=1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }